import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import cx from "classnames";

import {
  getCurrentDiagnosticQuestions,
  isHumanModelQuestion,
  isVASQuestion
} from "modules/diagnostic/diagnostic-selectors";
import DiagnosticActions from "modules/diagnostic/diagnostic-actions";
import QuestionSet from "modules/general-info/question-set";

class InitialDiagnostic extends Component {
  static propTypes = {
    questions: PropTypes.array,
    displayHelp: PropTypes.func.isRequired,
    navRef: PropTypes.node,
    optionalProgressBar: PropTypes.bool
  };

  render() {
    const {
      questions: currentQuestionsSet = [],
      displayHelp,
      optionalProgressBar
    } = this.props;

    return (
      <div
        className={cx("InitialDiagnostic", {
          OptionalProgressBar: optionalProgressBar
        })}
      >
        <h2>
          <FormattedMessage id="initial-diagnostic.title" />
        </h2>
        {currentQuestionsSet.length > 0 && <QuestionSet />}
        <button className="Button--help" onClick={displayHelp}>
          <FormattedMessage id="app.show-help" />
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    questions: getCurrentDiagnosticQuestions(state),
    optionalProgressBar: isVASQuestion(state) || isHumanModelQuestion(state)
  };
};

const mapDispatch = {
  displayHelp: DiagnosticActions.Creators.displayHelp
};

export default connect(
  mapStateToProps,
  mapDispatch
)(InitialDiagnostic);



// WEBPACK FOOTER //
// ./src/modules/general-info/initial-diagnostic.js